import { useState, useEffect } from 'react';
import api from '../api/client';
import { DEFAULT_PRICING } from '../constants';

// French euro formatting from cents, e.g. 500 -> "5,00 €" (comma decimal,
// space before the symbol) to match the format used across the UI.
const formatEuros = (cents) =>
  (cents / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + ' €';

/**
 * Fetches the single source of truth for pricing. Falls back silently to
 * DEFAULT_PRICING when the endpoint is unavailable so the UI stays functional.
 * Returns display-ready values (formatted prices + quotas) plus the raw config.
 */
export function usePricing() {
  const [pricing, setPricing] = useState(DEFAULT_PRICING);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get('/config/pricing/')
      .then(({ data }) => {
        if (active && data) setPricing(data);
      })
      .catch(() => {
        // Non-blocking: keep the DEFAULT_PRICING fallback.
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return {
    pricing,
    loading,
    formatEuros,
    unitPrice: formatEuros(pricing.unit_price_cents),
    standardPrice: formatEuros(pricing.standard_price_cents),
    proPrice: formatEuros(pricing.pro_price_cents),
    standardDeclarations: pricing.standard_declarations_per_month,
    proDeclarations: pricing.pro_declarations_per_month,
  };
}

export default usePricing;
